import { render, staticRenderFns } from "./AIReportConfig.vue?vue&type=template&id=435b43ab&scoped=true"
import script from "./AIReportConfig.vue?vue&type=script&lang=js"
export * from "./AIReportConfig.vue?vue&type=script&lang=js"
import style0 from "./AIReportConfig.vue?vue&type=style&index=0&id=435b43ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b43ab",
  null
  
)

export default component.exports